import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';

import {
    Box, Divider, Typography, Grid, Button,
    Container, Fab, FormControl, TextField,
    CircularProgress, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody,
    Autocomplete, MenuItem, Select, InputLabel, FormControlLabel, Checkbox, FormGroup
} from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import { formatMoney, } from '../../utils/functions/Utils';

const EditarProducto = () => {
    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState({
        nombre: '',
        descripcion: '',
        clave: '',
        categoria: '',
    });

    const [precioUnitario, setPrecioUnitario] = useState('');
    const [precioDistribuidor, setPrecioDistribuidor] = useState('');

    const [loading, setLoading] = useState(true);
    const [ubicacion, setUbicacion] = useState({ almacen: '', anaquel: '', nivel: '', posicion: '' });
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const [categoria, setCategoria] = useState();
    const [categories, setCategories] = useState([{}]);

    const [almacen, setAlmacen] = useState('');
    const [almacenes, setAlmacenes] = useState([{}]);

    const [catalogo, setCatalogo] = useState([true]);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (!['Admin', 'Almacen', 'Ayudante', 'Secretaria'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Editar producto';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    useEffect(() => {
        getData();
        return () => { }
    }, [])

    const getData = async () => {
        setLoading(true);
        try {
            let res = await axios.get(`/api/products/${id}`);
            if (res.status === 200) {
                setData(res.data);
                setPrecioUnitario(res.data.precioUnitario ? res.data.precioUnitario : 0);
                setPrecioDistribuidor(res.data.precioDistribuidor ? res.data.precioDistribuidor : 0);
                setUbicacion(res.data.ubicacion);
                setCategoria(res.data.categoria);
                setAlmacen(res.data.ubicacion.almacen);
                setCatalogo(res.data.catalogo);
            }
            res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setCategories(res.data.categorias);
            }
            res = await axios.get('/api/warehouses');
            if (res.status === 200) {
                setAlmacenes(res.data);
            }
            setLoading(false);

        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar el producto, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
            setLoading(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let product = data;
        product.precioUnitario = isNaN(Number(precioUnitario)) ? 0 : Number(precioUnitario);
        product.precioDistribuidor = isNaN(Number(precioDistribuidor)) ? 0 : Number(precioDistribuidor);
        product.imagen = product.imagen ? product.imagen.replace('https://drive.google.com/file/d/', 'https://drive.google.com/uc?export=view&id=').replace('/view?usp=drive_link', '') : '';
        product.ubicacion = {
            almacen: almacen,
            anaquel: ubicacion.anaquel,
            nivel: ubicacion.nivel,
            posicion: ubicacion.posicion
        };
        product.categoria = categoria;
        catalogo ? product.catalogo = true : product.catalogo = false;
        setButtonDisabled(true);
        try {
            const res = await axios.post(`/api/products/${data._id}`, { product: product });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'El producto fue actualizado con exito', severity: 'success' } });
                setButtonDisabled(false);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al actualizar el producto, favor de intentarlo mas tarde', severity: 'error' } });
            setButtonDisabled(false);
            console.log(err);
        }
    }

    const renderProductDetails = () => {
        return (
            <Box sx={{ border: 'solid 1px comp.boxBorder', backgroundColor: 'comp.boxBg', borderRadius: '20px', padding: '24px', marginBottom: '24px' }}>
                <Box className='d-flex align-items-stretch justify-content-center mb-2'>
                    <Typography sx={{ fontSize: '1.5em', color: 'comp.spColor2' }} className='px-1 d-flex align-items-center'>Nombre del producto:</Typography>
                    <Typography sx={{ fontSize: '1.5em' }} className='px-1 text-bold'>{data.nombre ? data.nombre : ''}</Typography>
                </Box>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <img alt='product-img' style={{ width: 'auto', maxWidth: '400px', maxHeight: '300px', boxShadow: '2px 2px 10px #13161B', borderRadius: '20px' }} src={data.imagen} />
                        </Box>
                        <Box className='d-flex align-items-stretch justify-content-center'>
                            <Typography sx={{ fontSize: '18px', color: 'comp.spColor1' }} className='my-3 px-1 d-flex align-items-center'>Unidades disponibles:</Typography>
                            <Typography sx={{ fontSize: '18px' }} className='my-3 px-1 text-bold'>{data.cantidad ? data.cantidad + ' ' + data.unidad : ''}</Typography>
                        </Box>
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Descripción:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.descripcion ? data.descripcion : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Clave del Producto:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.clave ? data.clave : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Categoría:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.categoria ? data.categoria : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Costo Unitario:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.costoUnitario ? `$ ${formatMoney(data.costoUnitario)}` : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Precio Unitario:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{precioUnitario ? `$ ${formatMoney(precioUnitario)}` : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Precio Distribuidor:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{precioDistribuidor ? `$ ${formatMoney(precioDistribuidor)}` : ''}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '16px', color: 'comp.spColor2' }}>Dimensiones:</TableCell>
                                        <TableCell sx={{ fontSize: '16px' }} className='text-bold'>{`${data.largo ? data.largo : '? '} x ${data.ancho ? data.ancho : '?'} x ${data.alto ? data.alto : '?'}`}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Proveedor:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.proveedor ? data.proveedor : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Marca:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.marca ? data.marca : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Modelo:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.modelo ? data.modelo : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>No. Serie:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.noSerie ? data.noSerie : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>No. Inventario:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.noInventario ? data.noInventario : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Unidad:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.unidad ? data.unidad : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Caducidad:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.caducidad ? data.caducidad : ''}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '18px', color: 'comp.spColor2' }}>Observaciones:</TableCell>
                                        <TableCell sx={{ fontSize: '18px' }} className='text-bold'>{data.observaciones ? data.observaciones : ''}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={12}>
                        <Box className='d-flex align-items-stretch'>
                            <p style={{ width: '160px', fontSize: '18px', color: 'comp.spColor2' }} className='mb-1 px-1 d-flex align-items-center'>Ubicación:</p>
                        </Box>
                        <Box className='d-flex align-items-stretch'>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '18px' }} className='text-center'>Almacén</TableCell>
                                            <TableCell sx={{ fontSize: '18px' }} className='text-center'>Anaquel</TableCell>
                                            <TableCell sx={{ fontSize: '18px' }} className='text-center'>Nivel</TableCell>
                                            <TableCell sx={{ fontSize: '18px' }} className='text-center'>Posición</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '18px', color: 'comp.spColor1' }} className='text-bold text-center'>{data.ubicacion.almacen ? data.ubicacion.almacen : ''}</TableCell>
                                            <TableCell sx={{ fontSize: '18px', color: 'comp.spColor1' }} className='text-bold text-center'>{data.ubicacion.anaquel ? data.ubicacion.anaquel : ''}</TableCell>
                                            <TableCell sx={{ fontSize: '18px', color: 'comp.spColor1' }} className='text-bold text-center'>{data.ubicacion.nivel ? data.ubicacion.nivel : ''}</TableCell>
                                            <TableCell sx={{ fontSize: '18px', color: 'comp.spColor1' }} className='text-bold text-center'>{data.ubicacion.posicion ? data.ubicacion.posicion : ''}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                </Grid>
                <p></p>
            </Box>
        )
    }

    const onChangePrecioUnitario = (e) => {
        setPrecioUnitario(e.target.value);
        setPrecioDistribuidor(Number(e.target.value) / 1.2);
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

            {loading ?
                <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                    <CircularProgress size='5em' color='primary' />
                </Box> :
                <Paper sx={{ padding: '24px 0px' }} elevation={3}>
                    <Container maxWidth='xl'>
                        {renderProductDetails()}
                        <Box className='text-center' >
                            <Typography variant='h5' style={{ fontWeight: 700 }}>Editar Producto</Typography>
                        </Box>

                        <Divider className='my-3' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Detalles del producto' className='text-bold' />
                        </Divider>

                        <form onSubmit={(e) => handleSubmit(e)}>
                            <Fab aria-label="add" type='submit' color='success' style={{ position: 'fixed', top: '70px', left: '24px', zIndex: '10', opacity: '75%' }}>
                                <i className="fad fa-save fa-2x"></i>
                            </Fab>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Producto" variant="outlined" multiline={true} value={data.nombre} onChange={(e) => setData({ ...data, nombre: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Descripción" variant="outlined" multiline={true} value={data.descripcion} onChange={(e) => setData({ ...data, descripcion: e.target.value })} />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled={!['Admin', 'Almacen'].includes(auth.user.rol)} label="Clave del Producto" variant="outlined" value={data.clave} onChange={(e) => setData({ ...data, clave: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <Autocomplete
                                            disablePortal
                                            freeSolo={true}
                                            onInputChange={(event, newInputValue) => setCategoria(newInputValue)}
                                            inputValue={categoria}
                                            aria-multiline='true'
                                            options={categories.map((option) => option.nombre)}
                                            renderInput={(params) => <TextField {...params} label='Categoría' helperText='Seleccione una categoría de la lista.' />}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled={!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)} error={isNaN(Number(data.costoUnitario)) ? true : false} helperText={isNaN(Number(data.costoUnitario)) ? 'El costo debe ser un número' : `$ ${formatMoney(data.costoUnitario)}`} label="Costo unitario" variant="outlined" value={data.costoUnitario} onChange={(e) => setData({ ...data, costoUnitario: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled={!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)} error={isNaN(Number(precioUnitario)) ? true : false} helperText={isNaN(Number(precioUnitario)) ? 'El precio debe ser un número' : `$ ${formatMoney(precioUnitario)}`} label="Precio unitario" variant="outlined" value={precioUnitario} onChange={(e) => onChangePrecioUnitario(e)} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled={!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)} error={isNaN(Number(precioDistribuidor)) ? true : false} helperText={isNaN(Number(precioDistribuidor)) ? 'El precio debe ser un número' : `$ ${formatMoney(precioDistribuidor)}`} label="Precio distribuidor" variant="outlined" value={precioDistribuidor} onChange={(e) => setPrecioDistribuidor(e.target.value)} />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Cantidad" variant="outlined" value={data.cantidad} onChange={(e) => setData({ ...data, cantidad: Number(e.target.value) })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Proveedor" variant="outlined" value={data.proveedor} onChange={(e) => setData({ ...data, proveedor: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Imagen" variant="outlined" value={data.imagen} onChange={(e) => setData({ ...data, imagen: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Stock minimo" variant="outlined" value={data.stockMinimo} onChange={(e) => setData({ ...data, stockMinimo: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Stock Maximo" variant="outlined" value={data.stockMaximo} onChange={(e) => setData({ ...data, stockMaximo: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Nota de Stock" variant="outlined" value={data.notaDeStock} onChange={(e) => setData({ ...data, notaDeStock: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormGroup sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <FormControlLabel labelPlacement="start" label='Mostrar en Catálogo' control={<Checkbox checked={catalogo} onChange={() => setCatalogo(catalogo => !catalogo)} />} />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Ubicacion de almacén' className='text-bold' />
                            </Divider>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <InputLabel id="select">Almacén</InputLabel>
                                        <Select
                                            required
                                            disabled={!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)}
                                            labelId="select"
                                            value={almacen}
                                            label="Almacén"
                                            onChange={(e) => setAlmacen(e.target.value)}
                                        >
                                            {almacenes.map((x, i) => (
                                                <MenuItem key={i} value={x.almacen}>{x.almacen}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled={!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)} label="Anaquel" variant="outlined" value={ubicacion.anaquel} onChange={(e) => setUbicacion({ ...ubicacion, anaquel: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled={!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)} label="Nivel" variant="outlined" value={ubicacion.nivel} onChange={(e) => setUbicacion({ ...ubicacion, nivel: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled={!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)} label="Posición" variant="outlined" value={ubicacion.posicion} onChange={(e) => setUbicacion({ ...ubicacion, posicion: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Dimensiones del producto' className='text-bold' />
                            </Divider>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Largo (x)" variant="outlined" value={data.largo} onChange={(e) => setData({ ...data, largo: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Ancho (y)" variant="outlined" value={data.ancho} onChange={(e) => setData({ ...data, ancho: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Alto (z)" variant="outlined" value={data.alto} onChange={(e) => setData({ ...data, alto: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Caracteristicas del producto' className='text-bold' />
                            </Divider>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Marca" variant="outlined" value={data.marca} onChange={(e) => setData({ ...data, marca: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Modelo" variant="outlined" value={data.modelo} onChange={(e) => setData({ ...data, modelo: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="No. de Serie" variant="outlined" value={data.noSerie} onChange={(e) => setData({ ...data, noSerie: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="No. de Inventario" variant="outlined" value={data.noInventario} onChange={(e) => setData({ ...data, noInventario: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Unidad" variant="outlined" value={data.unidad} onChange={(e) => setData({ ...data, unidad: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Caducidad" variant="outlined" value={data.caducidad} onChange={(e) => setData({ ...data, caducidad: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Observaciones" variant="outlined" value={data.observaciones} multiline={true} onChange={(e) => setData({ ...data, observaciones: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <hr></hr>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Button disabled={buttonDisabled} className='my-2' size='large' variant="contained" color="success" type='submit'>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Container>

                    <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
                </Paper>
            }
        </Container>
    )

};

export default EditarProducto;